import { useTheme } from '@mui/material';
import { tt } from '#i18n/index.ts';
import { deriveMovieRibbonColor } from '../helpers/deriveRibbonColor.ts';
import { Ribbon } from '../styled.ts';
import { type MovieRibbonProps } from '../types.ts';

export const MovieRibbon = ({ status, sx }: MovieRibbonProps) => {
  const theme = useTheme();

  return (
    <Ribbon ribbonColor={deriveMovieRibbonColor(status, theme)} sx={sx}>
      <span>{tt(`ribbons.movieAndTv.${status}`)}</span>
    </Ribbon>
  );
};
